import React, { Component } from 'react';
import { CallAPI, parseIntFromStr } from '../../utils/util';
import { PatientNav } from './patientnav';
import { FunnelNav } from './funnelNav';
import {useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Alert } from 'react-bootstrap';

function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        let location = useLocation();
        let navigate = useNavigate();
        let params = useParams();
        let [searchParams] = useSearchParams();

        return (
            <Component
                {...props}
                router={{ location, navigate, params, searchParams }}
            />
        );
    }
    return ComponentWithRouterProp;
}

class ReviewSystems extends Component {
    constructor(props) {
        super(props);
        this.state = {
            patientID: parseIntFromStr(this.props.router.params.patientId),
            history: [],
        }
        this.getItems = this.getItems.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)

        // Is this page being access as a funnel mode?
        this.funnel = this.props.router.searchParams.get('funnel') ? "?funnel=1" : ""
    }

    componentDidMount() {
        for(var i = 1; i <= 14; i++) {
            CallAPI(this.state, `patients/${this.state.patientID}/${i}/record`, `GET`, (res) => {
                this.setState(prev => {
                    let historyCopy = JSON.parse(JSON.stringify(prev.history))
                    // Avoid duplicates — replace if section_id already exists
                    const existingIdx = historyCopy.findIndex(h => h.section_id === res.section_id);
                    if (existingIdx >= 0) {
                        historyCopy[existingIdx] = res;
                    } else {
                        historyCopy.push(res);
                    }
                    historyCopy.sort((a,b) => (a.section_id > b.section_id) ? 1 : -1)
                    return {history: historyCopy}
                })
            })
        }
    }

    render = () => {
        return (
            <div>
                <PatientNav patientId={this.state.patientID} />
                <div className="ci-page">
                    {this.funnel && <FunnelNav patientId={this.state.patientID} currentStep={4} />}
                    <div className="ci-header">
                        <h2>Review of Systems</h2>
                        <p>Select all symptoms and findings that apply</p>
                    </div>
                    {this.state.modalVariant && (
                        <Alert variant={this.state.modalVariant} className="ci-alert">{this.state.modalMessage}</Alert>
                    )}
                    <form onSubmit={(e) => this.handleSubmit(e)}>
                        {this.getItems()}
                        <div className="ci-submit-row">
                            <button type="submit" className="logSubmit ci-submit-btn">Save Changes</button>
                        </div>
                    </form>
                </div>
            </div>
        );
    }

    getItems() {
        return this.state.history.map((item, i) => (
            <div key={item.section_title} className="ci-card" style={{ marginBottom: '12px' }}>
                <div className="ci-card-label">{item.section_title}</div>
                <div className="pmh-grid">
                    {item.items.map((val, j) => (
                        <label key={val.title} className="pmh-option">
                            <input
                                type="checkbox"
                                checked={val.value}
                                loc={[i, j]}
                                onChange={(e) => this.handleChange(e)}
                            />
                            <span>{val.title}</span>
                        </label>
                    ))}
                </div>
            </div>
        ));
    }

    handleChange(e) {
        const target = e.target;
        let loc = target.getAttribute("loc").split(",")
        const {history} = this.state
        history[loc[0]]["items"][loc[1]] = {
            ...history[loc[0]]["items"][loc[1]],
            "value": target.checked
        }
        this.setState({history});
    }

    handleSubmit(e) {
        e.preventDefault();
        CallAPI(this.state.history, `patients/${this.state.patientID}/record`, 'PUT',
        (res) => {
            if (this.funnel){
                this.props.router.navigate("/patients/"+this.state.patientID+"/allergies"+this.funnel);
            } else {
                this.setState({
                "modalVariant": "success",
                "modalMessage": "Review of Systems has been saved"
                })
            }
        },
        (message) => {
            this.setState({
                "modalVariant": "danger",
                "modalMessage": "Review of Systems could not be saved."
            })
        })
    }
}

export default withRouter(ReviewSystems)